import React, { useState, useEffect } from 'react';

interface FadeInSectionProps {
  children: React.ReactNode;
  isVisible: boolean;
  delay?: number;
  className?: string;
}

export const FadeInSection: React.FC<FadeInSectionProps> = ({ 
  children, 
  isVisible, 
  delay = 0,
  className = '' 
}) => {
  const [shouldRender, setShouldRender] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        setShouldRender(true);
        // Trigger animation after render
        requestAnimationFrame(() => {
          setIsAnimating(true);
        });
      }, delay);
      
      return () => clearTimeout(timer);
    } else {
      setIsAnimating(false);
      setShouldRender(false);
    }
  }, [isVisible, delay]);

  if (!shouldRender) {
    return null;
  }

  return (
    <div 
      className={`transition-all duration-500 ease-out ${
        isAnimating 
          ? 'opacity-100 transform translate-y-0' 
          : 'opacity-0 transform translate-y-4'
      } ${className}`}
    >
      {children}
    </div>
  );
};

export default FadeInSection;
